export class ClientValidationFailedError extends Error {
  // workaround to make instanceof work as expected bc babel's built-ins
  // extensions don't work as expected:
  // https://stackoverflow.com/a/33877501
  constructor(...args) {
    super(...args);
    this.constructor = ClientValidationFailedError;
    Object.setPrototypeOf(this, ClientValidationFailedError.prototype);
  }
}

